/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: package-media-image-asset-list-component.ts
 *
 * Created by randysorensen on 9/17/18.
 */

function PackageMediaImageAssetListController (
    this: JS5Object,
    _: JS5Object,
    ModalService: JS5Object,
    PackageMediaService: JS5Object,
    PackageUtilService: JS5Object
) {

    //================//
    // Template Logic //
    //================//

    this.getImageList = (): JS5Object[] => {
        return PackageMediaService.getAssetList('Image');
    };

    this.isVisible = () => {
        return PackageMediaService.getValidationStatus('IMAGE') !== 'NOT APPLICABLE';
    };

    this.isEnabled = () => {
        return PackageMediaService.hasMainVideo();
    };

    this.getIngestPercent = () => {
        return PackageMediaService.calculateIngestPercent(this.getImageList());
    };

    this.getValidationStatus = () => {
        return PackageMediaService.getValidationStatus('IMAGE');
    };

    this.selectedImageAcceptTemplateMember = (newValue: JS5Object=null) => {
        if (newValue) {
            PackageMediaService.packageMediaData.selectedImageAcceptTemplateMember = newValue;
        }
        return PackageMediaService.packageMediaData.selectedImageAcceptTemplateMember;
    };

    const openChangeAcceptProfileConfirmationModal = (acceptHandler: JS5Function, rejectHandler: JS5Function) => {
        ModalService.showMessageModal(
            {
                messageText:
                    `Are you sure you want to change the package's image accept profile? This will remove all` +
                    ` image assets from the package.`,
                pullCancelLeft: true,
                title: 'Change Image Accept Profile',
                windowClass: 'confirm-modal-lg',
                showOK: true
            },
            acceptHandler,
            rejectHandler);
    };

    this.onImageAcceptTemplateMemberChanged = () => {
        const setNewImageAcceptTemplateMember = () => {
            _.remove(PackageMediaService.packageMediaData.assets, {type: 'Image'});
            this.oldSelectedImageAcceptTemplateMember =
                PackageMediaService.packageMediaData.selectedImageAcceptTemplateMember;
            PackageUtilService.editorForm.$setDirty();
        };

        const revertOldImageAcceptTemplateMember = () => {
            PackageMediaService.packageMediaData.selectedImageAcceptTemplateMember =
                this.oldSelectedImageAcceptTemplateMember;
        };

        if (!_.size(this.getImageList())) {
            setNewImageAcceptTemplateMember();
        } else {
            openChangeAcceptProfileConfirmationModal(
                setNewImageAcceptTemplateMember,
                revertOldImageAcceptTemplateMember);
        }
    };

    this.addNewImage = () => {
        PackageMediaService.packageMediaData.assets.push({
            acceptTemplateMember: PackageMediaService.packageMediaData.selectedImageAcceptTemplateMember,
            type: 'Image'
        });
        PackageUtilService.editorForm.$setDirty();
    };

    this.removeImage = (imageAsset: JS5Object) => {
        _.pull(PackageMediaService.packageMediaData.assets, imageAsset);
        PackageUtilService.editorForm.$setDirty();
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
        PackageMediaService.getPackageMediaData().then(() => {
            this.acceptTemplateMembers = PackageMediaService.packageMediaData.acceptTemplateMembers;
            this.oldSelectedImageAcceptTemplateMember =
                PackageMediaService.packageMediaData.selectedImageAcceptTemplateMember;
        });
    };

}

angular.module('prism-ui.package').component(
    'packageMediaImageAssetList',
    {
        controller: PackageMediaImageAssetListController,
        templateUrl: 'package/editor/components/view/media/assetList/imageAssetList/package-media-image-asset-list-template.html',
        bindings: {
        }
    });
